import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import MyProfile from '../components/properties/profile/MyProfile';
import { ProtectedRoute } from '../helpers/ProtectedRoute';
import MyFinanceLayout from '../layouts/MyFinanceLayout';

const MyRoutes = ({ match: { url } }) => 
  <Switch>
    <ProtectedRoute path={`${url}/finance`} rols={['property']} component={MyFinanceLayout} />
    <ProtectedRoute exact path={`${url}/profile`} rols={['manager', 'property','safety']} component={MyProfile} />
    <Redirect to="/errors/404" />
  </Switch>

MyRoutes.propTypes = { match: PropTypes.object.isRequired };

export default withRouter(MyRoutes);